import { extendTailwindMerge } from 'tailwind-merge';

export default extendTailwindMerge({
  prefix: 'tw-',
});
